import React, { Fragment, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login, getActiveUsers } from "../../actions/auth";
import { setAlert } from "../../actions/alert";

import GreenLogo from "../layout/Innovators/GreenLogo";
import IMEAltLogo from "../layout/IME/IMEAltLogo";
import Alert from "../layout/IME/Alert";
import RegisterUser from "../layout/Innovators/RegisterUser";

const Register = ({
  message: { users },
  getActiveUsers,
  login,
  isAuthenticated,
  setAlert,
}) => {
  const [profileDropDown, setprofileDropDown] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setAlert("Please enter a valid email");
    }
    if (password === "") {
      setAlert("Please enter a password");
    }
    login(email, password);
  };

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <section className="full-content">
        <nav className="login-nav background-dark-black border-bottom grey">
          <form
            className="main"
            action="/:channelid"
            method="POST"
            onSubmit={(e) => onSubmit(e)}
          >
            <div className="action-items-index">
              <Link to="/">
                <div className="action-button-index green">
                  <i className="fas fa-angle-left action-icon-index-alt fa-lg green"></i>
                </div>
              </Link>
              <p className="action-text-index green">Back</p>
            </div>
            <div className="action-items-index">
              <div
                className="action-button-index green"
                onClick={() => {
                  if (!profileDropDown) {
                    setprofileDropDown(true);
                  } else {
                    setprofileDropDown(false);
                  }
                }}
              >
                <i className="fas fa-user action-icon-index fa-lg green"></i>
              </div>
              <p className="action-text-index green">Login</p>
            </div>
            {profileDropDown && (
              <div className="profile-drop-down-alternate">
                <div className="profile-drop-container-nav">
                  <div className="label-input">
                    <label htmlFor="email" className="labels green">
                      *Email:
                    </label>
                    {email === "" && <Alert />}
                    <input
                      name="email"
                      className="input-style-nav"
                      type="text"
                      value={email}
                      placeholder="Enter Email Address"
                      onChange={(e) => onChange(e)}
                      tabIndex="2"
                    />
                  </div>
                  <div className="label-input">
                    <label htmlFor="password" className="labels green">
                      *Password:
                    </label>
                    {password === "" && <Alert />}
                    <input
                      name="password"
                      className="input-style-nav"
                      type="password"
                      value={password}
                      placeholder="Enter Password"
                      onChange={(e) => onChange(e)}
                      tabIndex="2"
                    />
                    <div className="login-button-container-alt">
                      <button
                        className="login-button-alt background-green"
                        type="submit"
                      >
                        Login
                      </button>
                    </div>
                    <Link to="/forgotpassword">
                      <p className="forgot green" tabIndex="4">
                        Forgot Password?
                      </p>
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </form>
          <div className="center-nav">
            <div className="index-logo-alt">
              <GreenLogo />
            </div>
            <i className="fas fa-trademark green fa-sm mt-10"></i>
            <div className="index-logo">
              <IMEAltLogo />
            </div>
          </div>
        </nav>
      </section>
      <div className="flex-all-content-fixed">
        <div className="main-content">
          <div className="feature-register-container">
            {/* <RegisterUser getActiveUsers={getActiveUsers} users={users} /> */}
            <div className="coming-soon green">COMING SOON</div>
          </div>
          <section className="site-features-alt grey">
            <div className="feature-container">
              <div className="feature-name-container">
                <p className="feature-name green">Intellectual Networking</p>
              </div>
              <img
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/networking.jpg"
                }
                className="feature-image-container"
              />
              <div className="feature-description-container">
                <p className="feature-description">
                  ime provides a dynamic ecosystem where ideas and knowledge
                  flow seamlessly between individuals. It's about connecting
                  with others who share similar intellectual passions, fostering
                  a sense of collaboration and mutual growth. This network
                  enables professionals, academics, and enthusiasts to exchange
                  insights, challenge perspectives, and co-create innovative
                  solutions.
                </p>
              </div>
            </div>
            <div className="site-features">
              <div className="feature-container">
                <div className="feature-name-container">
                  <p className="feature-name green">Live Discussions</p>
                </div>
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/img/live_discussion.jpg"
                  }
                  className="feature-image-container"
                />
                <div className="feature-description-container">
                  <p className="feature-description">
                    Do you thrive on discussions and brainstorming quick
                    thoughts and ideas? ime Live Discussions offers a
                    fast-paced, engaging way to interact and share your ideas.
                    Enjoy thought-provoking conversations in one-on-one,
                    panel-style, or group discussions, allowing you to exchange
                    and appreciate a diverse range of opinions and insights.
                    It's a fun and dynamic way to spark creativity and
                    collaboration!
                  </p>
                </div>
              </div>
              <div className="site-features">
                <div className="feature-container">
                  <div className="feature-name-container">
                    <p className="feature-name green">Articles</p>
                  </div>
                  <img
                    src={
                      "https://ime.sfo3.cdn.digitaloceanspaces.com/img/articles.jpg"
                    }
                    className="feature-image-container"
                  />
                  <div className="feature-description-container">
                    <p className="feature-description">
                      Innovators can publish online articles to share thoughts,
                      ideas, and opinions with ime Articles. By doing so, they
                      can reach a global audience and spark meaningful
                      discussions. Additionally, these articles can showcase
                      their expertise and attract opportunities for
                      collaboration and growth.
                    </p>
                  </div>
                </div>
              </div>
              <div className="site-features">
                <div className="feature-container">
                  <div className="feature-name-container">
                    <p className="feature-name green">Career Search</p>
                  </div>
                  <img
                    src={
                      "https://ime.sfo3.cdn.digitaloceanspaces.com/img/career_search.jpg"
                    }
                    className="feature-image-container"
                  />
                  <div className="feature-description-container">
                    <p className="feature-description">
                      Search for careers effortlessly on ime. Our aim is to
                      attract both sought-after positions and common roles to
                      accommodate Innovators from all backgrounds. Upload your
                      resume or utilize ime's resume builder to discover your
                      next career adventure.
                    </p>
                  </div>
                </div>
              </div>
              <div className="site-features">
                <div className="feature-container">
                  <div className="feature-name-container">
                    <p className="feature-name green">
                      Make ime your "Online Home"
                    </p>
                  </div>
                  <img
                    src={
                      "https://ime.sfo3.cdn.digitaloceanspaces.com/img/ime_home.jpg"
                    }
                    className="feature-image-container"
                  />
                  <div className="feature-description-container">
                    <p className="feature-description">
                      While we've shared our vision for the site, its true
                      potential will be realized through the contributions of
                      its users. Make ime your online home—a place designed to
                      equip you with the skills, habits, and abilities that can
                      positively impact your life in the real world.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Fragment>
  );
};

Register.propTypes = {
  login: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  message: state.message,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { login, getActiveUsers, setAlert })(
  Register
);
